module.exports = __webpack_public_path__ + "img/spinner.32a45e9f.gif";